function n(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1?arguments[1]:void 0,i=n.find((function(n){return void 0!==n}));return i||t}export{n as backwardCompatibilityForProperties};
